export const AUTOMATION_CANVAS_PATH = (id: string | number = ':id') => `/automations/${id}`;

export const MANAGE_AUTOMATIONS_PATH = '/automations/manage';

export const AUTOMATION_REPORT_PATH = (id: string | number = ':id') => `/automations/${id}/report`;

export const EXECUTION_REPORT_PATH = (
  automationId: string | number,
  executionId: string | number = ':id',
) => `/automations/${automationId}/report/${executionId}`;
